import setStatusPatients from './setStatusPatients';
import setMoreStatusPatients from './setMoreStatusPatients';
import reset from './reset';
import setUpdatedBloodPressureReading from './setUpdatedBloodPressureReading';

export default {
  setStatusPatients,
  setMoreStatusPatients,
  reset,
  setUpdatedBloodPressureReading,
};
